<div class="p-4">
  <h1 class="flex gap-1 items-center justify-center text-2xl text-center">
    <svg mib-warning-icon class="text-error shrink-0 h-8"></svg>
    The precall test does not support your browser.
  </h1>
  <p class="text-center">Please use the latest version of one of these browsers.</p>

  <div class="flex justify-center items-center gap-20 mt-12 flex-wrap">
    <div class="browser">
      <a
        class="inline-flex justify-center items-center flex-col gap-4 text-black !no-underline text-2xl transition-all hover:scale-[1.1]"
        href="https://www.google.com/chrome/"
        target="_blank"
        rel="noreferrer noopener"
        >Chrome <fa-icon class="text-6xl text-gray-800" [icon]="faChrome"></fa-icon
      ></a>
    </div>
    <div class="browser">
      <a
        class="inline-flex justify-center items-center flex-col gap-4 text-black !no-underline text-2xl transition-all hover:scale-[1.1]"
        href="https://www.microsoft.com/en-us/edge"
        target="_blank"
        rel="noreferrer noopener"
        >Edge <fa-icon class="text-6xl text-gray-800" [icon]="faEdge"></fa-icon
      ></a>
    </div>
    <div class="browser">
      <a
        class="inline-flex justify-center items-center flex-col gap-4 text-black !no-underline text-2xl transition-all hover:scale-[1.1]"
        href="https://www.apple.com/safari/"
        target="_blank"
        rel="noreferrer noopener"
        >Safari <fa-icon class="text-6xl text-gray-800" [icon]="faSafari"></fa-icon
      ></a>
    </div>
    <div class="browser">
      <a
        class="inline-flex justify-center items-center flex-col gap-4 text-black !no-underline text-2xl transition-all hover:scale-[1.1]"
        href="https://www.opera.com/"
        target="_blank"
        rel="noreferrer noopener"
        >Opera <fa-icon class="text-6xl text-gray-800" [icon]="faOpera"></fa-icon
      ></a>
    </div>
  </div>

  <div class="pt-12 flex items-center justify-center">
    @if (displayCloseButton) {
      <mib-button (click)="onClickTerminate($event)">Close</mib-button>
    }
  </div>
</div>
